const cache = new Map()
const CACHE_DURATION = 10000 // 10 second in milliseconds

export function calculateAscenderHeightRatio(elem) {
  const computedStyle = getComputedStyle(elem)
  const cacheKey = `${computedStyle.fontSize}|${computedStyle.fontWeight}|${computedStyle.fontFamily}`

  const cached = cache.get(cacheKey)
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.ratio
  }

  // The container is a little defensive.
  const container = document.createElement('div')
  container.style.display = 'block'
  container.style.position = 'absolute'
  container.style.bottom = '0'
  container.style.right = '0'
  container.style.width = '0px'
  container.style.height = '0px'
  container.style.margin = '0'
  container.style.padding = '0'
  container.style.visibility = 'hidden'
  container.style.overflow = 'hidden'
  container.style.fontSize = computedStyle.fontSize
  container.style.fontWeight = computedStyle.fontWeight
  container.style.fontFamily = computedStyle.fontFamily

  const small = document.createElement('span')
  const large = document.createElement('span')

  // Large numbers help improve accuracy.
  small.style.fontSize = '0px'
  large.style.fontSize = '2000px'

  small.innerHTML = 'h'
  large.innerHTML = 'h'

  container.appendChild(small)
  container.appendChild(large)

  // Put the element in the DOM for a split second.
  document.body.appendChild(container)
  const smalldims = small.getBoundingClientRect()
  const largedims = large.getBoundingClientRect()
  document.body.removeChild(container)

  // Calculate where the ascender was, percentage-wise.
  const ascenderPosition = smalldims.top - largedims.top
  const height = largedims.height

  const ratio = 1 - ascenderPosition / height

  cache.set(cacheKey, { ratio, timestamp: Date.now() })

  return ratio
}

// Loads a Google font through our first-party /_fonts proxy (GoogleFontsProxy, ENG-35583), so the
// visitor's browser never talks to Google. Resolved against the page's host, which a CSS @import in
// bundled CSS can't do: that resolves against the asset host.
//
// `family` is a css2 family spec, e.g. "Inter:wght@400;700". The path mirrors
// GoogleFontsProxy.css_path (GoogleFontsProxy::PATH_PREFIX + '/css2').
export function loadGoogleFont(family) {
  const href = `/_fonts/css2?family=${family.replaceAll(' ', '+')}&display=swap`
  const loaded = [...document.querySelectorAll('link[rel="stylesheet"]')].some(
    (link) => link.getAttribute('href') === href
  )
  if (loaded) return

  document.head.appendChild(
    Object.assign(document.createElement('link'), { rel: 'stylesheet', href })
  )
}
